<script setup lang="ts">
import { ref } from 'vue';
import { EMIT } from '@/enum';

const emit = defineEmits<{
  (e: EMIT.ENABLE): void;
  (e: EMIT.DISABLE): void;
}>();
const showExpired = ref(false);
const handleToggle = () => (showExpired.value ? emit(EMIT.ENABLE) : emit(EMIT.DISABLE));
</script>

<template>
  <div class="inline-flex align-items-center">
    <InputSwitch v-model="showExpired" @change="handleToggle" />
    <p class="text-gray-600 label pl-2 align-items-center flex font-semibold">Show Expired</p>
  </div>
</template>

<style lang="scss" scoped></style>
